import React from 'react';
import { Badge } from './ui/badge';
import { useLang } from '../i18n/LanguageContext';

export const About = () => {
  const { t } = useLang();

  return (
    <section id="about" className="pt-8 pb-8 lg:pt-12 lg:pb-12">
      <div className="section-container">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-8 lg:mb-12 text-center"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t.about.title}
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            <div className="lg:col-span-7 space-y-6">
              <p className="text-lg text-muted-foreground leading-relaxed">{t.about.p1}</p>
              <p className="text-lg text-muted-foreground leading-relaxed">{t.about.p2}</p>
              <p className="text-lg text-muted-foreground leading-relaxed">{t.about.p3}</p>
              <p className="text-lg text-muted-foreground leading-relaxed">{t.about.p4}</p>

              <div className="pt-4 border-l-2 border-accent pl-6 mt-8">
                <p className="text-lg italic text-foreground font-medium">{t.about.quote}</p>
                <p className="text-sm text-muted-foreground mt-2">{t.about.quoteAuthor}</p>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="relative">
                <img
                  src="/raul-profile.jpg"
                  alt="Raúl de la Fuente"
                  className="w-full h-auto rounded-sm shadow-lg"
                />
              </div>
            </div>
          </div>

          <div className="mt-12">
            <h3 className="text-2xl font-semibold mb-6 text-foreground text-center">
              {t.about.expertiseTitle}
            </h3>
            <div className="flex flex-wrap gap-3 justify-center max-w-3xl mx-auto">
              {t.about.expertise.map((skill, index) => (
                <Badge
                  key={index}
                  variant="outline"
                  className="px-4 py-2 text-sm font-medium border-border bg-muted/20 text-foreground hover:bg-muted/40 hover:border-muted transition-colors"
                >
                  {skill}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="section-divider" />
    </section>
  );
};
